export const BROADCAST_CHANNELS = {
	AUTH_TOKEN: "AUTH_TOKEN",
	PROJECT: "PROJECT",
};
